import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@mui/material';
import React from 'react';
import { DateFilter, DateFilterLabel } from 'types/chart';
import { SelectOption } from 'types/common';

interface Props extends ToggleButtonGroupProps {
  buttons: SelectOption[];
}

function ChartDateToggleButtonGroup({ buttons, value, onChange }: Props) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      sx={{
        '&.MuiToggleButtonGroup-root': {
          padding: '5px',
          background: '#F5F5F5',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'auto',
        },
        '.MuiToggleButton-root': {
          border: 'none',
          borderRadius: '4px',
          whiteSpace: 'pre',
        },

        '.MuiToggleButton-root.Mui-selected': {
          '&:hover': {
            backgroundColor: 'auto',
            borderRadius: '4px',
            boxShadow: ' 0px 0px 6px 0px rgba(0, 30, 81, 0.16)',
          },
          background: '#fff',
          color: '#333',
        },
        '.MuiButtonBase-root': {
          fontWeight: 700,
          minWidth: '65px',
          height: '23px',
          padding: '6px',
          fontSize: '12px',
        },
      }}
    >
      {buttons.map(({ value, label }) => (
        <ToggleButton value={value} key={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export default ChartDateToggleButtonGroup;
